const IconCalendar = ({ color }) => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.75 3C23.5449 3 25 4.45507 25 6.25V21.75C25 23.5449 23.5449 25 21.75 25H6.25C4.45507 25 3 23.5449 3 21.75V6.25C3 4.45507 4.45507 3 6.25 3H21.75ZM21.75 4.5H6.25C5.2835 4.5 4.5 5.2835 4.5 6.25V21.75C4.5 22.7165 5.2835 23.5 6.25 23.5H21.75C22.7165 23.5 23.5 22.7165 23.5 21.75V6.25C23.5 5.2835 22.7165 4.5 21.75 4.5ZM19 12C19.5523 12 20 12.4477 20 13V19C20 19.5523 19.5523 20 19 20H9C8.44772 20 8 19.5523 8 19V13C8 12.4477 8.44772 12 9 12H19ZM18.5 13.5H9.5V18.5H18.5V13.5ZM19 8C19.4142 8 19.75 8.33579 19.75 8.75C19.75 9.1297 19.4678 9.44349 19.1018 9.49315L19 9.5H9C8.58579 9.5 8.25 9.16421 8.25 8.75C8.25 8.3703 8.53215 8.05651 8.89823 8.00685L9 8H19Z"
        fill={color}
      />
    </svg>
  )
}

export default IconCalendar
